import { Lightning } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { CmsBorder } from './CmsBorder';
import { CmsConstants } from '../../Business/cms/CmsConstants';
import { Spinner } from '../shared/Spinner';

export class CmsCardDummy extends Lightning.Component {
  static _template() {
    const dims = CmsConstants.Card;
    const padding = dims.imageOffset + dims.imageOffset;
    return {
      x: 0,
      y: 0,
      w: w => w,
      h: h => h,
      Content: {
        x: dims.imageOffset,
        y: dims.imageOffset,
        w: w => w - padding,
        h: h => h - padding,
        Background: {
          x: -1,
          y: 0,
          w: w => w + 2,
          h: h => h,
          rect: true,
          color: Theme.Colors.Ribbon.Card.Background,
          shader: {
            type: Lightning.shaders.RoundedRectangle,
            radius: dims.innerRadius,
          },
        },
        // Image: {
        //   type: CmsCardImage,
        //   x: -1,
        //   y: -1,
        //   w: w => w + 2,
        //   h: h => h + 2,
        // },
        Spinner: {
          type: Spinner,
          x: w => w * 0.5,
          y: h => h * 0.5,
          mount: 0.5,
          visible: true,
        },
      },
      Border: {
        type: CmsBorder,
        alpha: 0,
      },
    };
  }

  _init() {
    // console.log(this.data);
  }

  _active() {
    // this.visible = false;
    this.signal('startLazyLoad');
  }

  _focus() {
    this.tag('Border').setSmooth('alpha', 1);
  }

  _unfocus() {
    this.tag('Border').setSmooth('alpha', 0);
  }

  stopLoading() {
    this.tag('Spinner').visible = false;
  }

  startLoading() {
    this.tag('Spinner').visible = true;
  }
}
